import React from 'react';

const ExitBoldIcon = ({
  width = '16',
  height = '16',
  fill = '#FF0000',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7 1.8C11.7 1.32261 11.5104 0.864773 11.1728 0.527208C10.8352 0.189642 10.3774 0 9.9 0L1.8 0C1.32261 0 0.864773 0.189642 0.527208 0.527208C0.189642 0.864773 0 1.32261 0 1.8L0 16.2C0 16.6774 0.189642 17.1352 0.527208 17.4728C0.864773 17.8104 1.32261 18 1.8 18H9.9C10.3774 18 10.8352 17.8104 11.1728 17.4728C11.5104 17.1352 11.7 16.6774 11.7 16.2V12.1698H7.2C6.36457 12.1698 5.56335 11.8379 4.97261 11.2472C4.38187 10.6564 4.05 9.85523 4.05 9.0198C4.05 8.18437 4.38187 7.38315 4.97261 6.79241C5.56335 6.20167 6.36457 5.8698 7.2 5.8698H11.7V1.8ZM13.518 5.2812C13.7237 5.1956 13.9502 5.173 14.1687 5.21626C14.3873 5.25952 14.588 5.36669 14.7456 5.5242L17.4456 8.2242C17.5501 8.32867 17.633 8.4527 17.6895 8.58921C17.7461 8.72572 17.7752 8.87204 17.7752 9.0198C17.7752 9.16756 17.7461 9.31388 17.6895 9.45039C17.633 9.5869 17.5501 9.71093 17.4456 9.8154L14.7456 12.5154C14.5883 12.6728 14.3878 12.78 14.1695 12.8234C13.9513 12.8668 13.725 12.8445 13.5195 12.7594C13.3139 12.6742 13.1381 12.53 13.0145 12.3449C12.8909 12.1599 12.825 11.9423 12.825 11.7198V10.3698H7.2C6.84196 10.3698 6.49858 10.2276 6.24541 9.97439C5.99223 9.72122 5.85 9.37784 5.85 9.0198C5.85 8.66176 5.99223 8.31838 6.24541 8.06521C6.49858 7.81203 6.84196 7.6698 7.2 7.6698H12.825V6.3198C12.825 5.8644 13.0968 5.4558 13.518 5.2812Z"
      fill={fill}
    />
  </svg>
);

export default ExitBoldIcon;
